import endpoints from "config/endpoints";

const exportUrlBuilder =
  (overrideToSiteTimeZone) =>
  ({ startDate, endDate }, includeUnavailability) => {
    const overriddenFromDate = overrideToSiteTimeZone(startDate);
    let overriddenToDate = "";
    if (endDate) overriddenToDate = overrideToSiteTimeZone(endDate);

    return `${endpoints.exportSchedule}?from_date=${overriddenFromDate}&to_date=${overriddenToDate}&include_unavailability=${includeUnavailability}`;
  };

export default exportUrlBuilder;
